import { Alert, FormControl, Grid, MenuItem, TextField } from "@mui/material"
import { Eye } from "react-feather"

export const InfoApproval = ({ useFetchInit }) => {
    const { Forms } = useFetchInit
    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen

    const severityMessage = formState.aprobacion_check === 'Aprobado' ? 'success':'error'
    return (
        <>
            <div className="pt-4"></div>
            <p>Información de la aprobación</p>
            <div className="border-bottom border-dark"></div>
            <div className="pt-4"></div>
            <Alert icon={<Eye fontSize="inherit" />} severity={severityMessage}>
                {formState.aprobacion_check}
            </Alert>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_check">* Tipo</label>
                        <TextField
                            id="aprobacion_check"
                            name="aprobacion_check"
                            value={formState.aprobacion_check}
                            onChange={onInputChange}
                            select
                            size="small"
                            variant="outlined"
                            hiddenLabel
                            InputProps={{ 
                                readOnly: true
                            }}
                        >
                            <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                            <MenuItem value='Pendiente Aprobacion'>Pendiente Aprobacion</MenuItem>
                            <MenuItem value='Aprobado'>Aprobado</MenuItem>
                            <MenuItem value='Rechazado'>Rechazado</MenuItem>
                            {(formState.idgestiontipo === 2)&&(
                                <MenuItem value='Traslado Aprobado'>Traslado Aprobado</MenuItem>
                            )}
                            {(formState.idgestiontipo === 2)&&(
                                <MenuItem value='Revisión de Depósito'>Revisión de Depósito</MenuItem>
                            )}
                            {(formState.idgestiontipo === 4)&&(
                                <MenuItem value='Esperando Reintegro'>Esperando Reintegro</MenuItem>
                            )}
                            {(formState.idgestiontipo === 5)&&(
                                <MenuItem value='Pago Aprobado'>Pago Aprobado</MenuItem>
                            )}
                            
                        </TextField>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_fecha">Fecha de aprobacion / registro</label>
                        <TextField
                            id='aprobacion_fecha'
                            name='aprobacion_fecha'
                            value={ formState.aprobacion_fecha } 
                            // onChange={ onInputChange }
                            size='small'
                            placeholder='Fecha de aprobacion'
                            type='date'
                            variant='filled'
                            hiddenLabel
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="aprobacion_observaciones">Observaciones de aprobación</label>
                        <TextField
                            id='aprobacion_observaciones'
                            name='aprobacion_observaciones'
                            value={ formState.aprobacion_observaciones } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Observaciones de aprobación'
                            type='text'
                            multiline
                            rows={5}
                            variant='filled'
                            InputProps={{
                                readOnly: true
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
